const Modal = ({ modalState, style = null, children }) => {

   const styleModal = Object.assign({
      position: "fixed",
      top: "50%",
      left: "50%",
      width: "80%",
      minWidth: "200px",
      height: "auto",
      maxHeight: "100%",
      minHeight: "40%",
      background: " rgba(0, 0, 0, 0.7)",
      color: "white",
      borderRadius: "10px",
      padding: "10px",
      boxShadow: "2px 2px 10px 5px white",
      transform: "translate(-50%,-50%)",
      overflow: "auto",
      zIndex: 99
   }, style); //! combine styles, style overwrites!

   return (
      <div style={{ display: modalState ? "block" : "none" }}
         className="modal"
      >
         {modalState ?
            <section style={styleModal}>
               {children}
            </section>
            : null}
      </div>
   );

};

export default Modal
